<div class="card-wrapper">
  <mat-card *ngIf="customOptions" class="card">
    <i class="{{customOptions.icon}} {{customOptions.iconClass}}" [style.fontSize]="customOptions.iconSize"
      [style.color]="customOptions.iconColor"
      [style.float]="customOptions.iconPosition == 'start' && dir == 'rtl' ? 'right' : 'left'"></i>

    <mat-card-header>
      <mat-card-title *ngIf="hasTitle" class="{{customOptions.titleClass}}"
        [style.color]="customOptions.titleColor" [style.fontSize]="customOptions.titleSize">
        {{customOptions.titleTranslatable ? ('forms.common.' + customOptions.title | translate) : customOptions.title}}
        <br />
      </mat-card-title>

      
      <mat-card-subtitle *ngIf="hasDescription" class="{{customOptions.descriptionClass}}"
        [style.color]="customOptions.descriptionColor" [style.fontSize]="customOptions.descriptionSize">
        {{customOptions.descriptionTranslatable ? ('forms.common.' + customOptions.description | translate) :
        customOptions.description}}
      </mat-card-subtitle>
    </mat-card-header>

    <mat-card-actions *ngIf="customOptions.actions" class="{{customOptions.actionsClass}}">
      <ng-container *ngFor="let action of customOptions.actions">
        <button mat-button [ngClass]="action.class" (click)="evaluateAction(action.event)">
          {{action.translatable ? ('forms.common.' + action.title | translate) : action.title}}
        </button>
      </ng-container>
    </mat-card-actions>
  </mat-card>
</div>